import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const campaignStorySegmentDistMetrics = gql`
    query CampaignStorySegmentDistributionMetrics($campaignId: ID!, $esSearchBody: JSON!) {
        campaign(id: $campaignId) {
            distributionMetricSearch(kind: INSTAGRAM_STORY_SEGMENT, search: $esSearchBody) {
                rawSearchResult
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./graphql/queries/campaign_story_segment_dist_metrics.js